import { MenuItem } from '@mui/material';
import clsx from 'clsx';
import EditableTitle, { useEditableTitle } from 'components/EditableTitle';
import { Dispatch } from 'react';
import useStyles from './styles';

type NewWorkspaceTitleProps = { onSave: Dispatch<string>; onCancel: () => void };

export const NewWorkspaceTitle = (props: NewWorkspaceTitleProps) => {
  const classes = useStyles();
  const { inputRef, inputValue, onChange, onSave, onCancel, onEdit } = useEditableTitle({
    initialEditMode: false,
    title: '',
    onSave: props.onSave,
    onCancel: props.onCancel,
  });
  return (
    <MenuItem href='' className={clsx(classes.editingMenuItem, classes.workspaceMenuItem)}>
      <EditableTitle
        hideEditIcon
        disableClickToEdit
        inputRef={inputRef}
        inputValue={inputValue}
        onChange={onChange}
        onCancel={onCancel}
        onSave={onSave}
        onEdit={onEdit}
        isEditMode={true}
        classes={{
          textField: classes.textField,
        }}
        title=''
      />
    </MenuItem>
  );
};
